import { h } from 'vue';
import { Button, notification } from 'ant-design-vue';

export function showDownloadNotification(link) {
    if (!link) return;

    const key = `download-${Date.now()}`;

    notification.open({
        key,
        message: 'Ссылка на файл',
        duration: 0,
        description: () =>
            h(
                'a',
                {
                    href: link,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    class: 'download-link',
                },
                link,
            ),
        btn: () =>
            h(
                Button,
                {
                    class: 'primary-button',
                    onClick: () => {
                        notification.close(key);
                        window.open(link, '_blank', 'noopener,noreferrer');
                    },
                },
                {
                    default: () => 'Скачать',
                },
            ),
    });
}